<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Name:</label>
        <div>
          <input type="text" placeholder="Name" v-model="editName" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>HTML:</label>
        <div>
          <textarea rows="5" placeholder="HTML" v-model="editHtml" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Email Title:</label>
        <div>
          <input
            type="text"
            placeholder="Email Title"
            v-model="editEmailTitle"
          />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Email Text:</label>
        <div>
          <textarea rows="5" placeholder="Email Text" v-model="editEmailText" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >{{ buttonLabel }}</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["submitLoading", "propsData"],
  components: {
    spinnerButton,
  },
  data() {
    return {
      panelTitle: null,
      buttonLabel: null,
      editType: null,
      editName: null,
      editHtml: null,
      editEmailTitle: null,
      editEmailText: null,
    };
  },
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  created: function () {
    this.initData();
  },
  methods: {
    initData: function () {
      this.editType = this.propsData.type;
      if (this.editType == "add") {
        this.panelTitle = "Add Application Status";
        this.buttonLabel = "Add Application Status";
      }
      if (this.editType == "edit") {
        this.panelTitle = "Edit Application Status";
        this.buttonLabel = "Edit Application Status";
      }
      this.editName = this.propsData.name;
      this.editHtml = this.propsData.html;
      this.editEmailTitle = this.propsData.emailTitle;
      this.editEmailText = this.propsData.emailText;
      this.editId = this.propsData.id;
    },
    buttonClick: function () {
      this.$emit(
        "buttonClick",
        this.editName,
        this.editHtml,
        this.editEmailTitle,
        this.editEmailText,
        this.editType,
        this.editId
      );
    },
  },
};
</script>
